import { useProductCacheStore } from "@faire/retailer-visitor-shared/stores/domain/ProductCacheStore";
import { useLocalization } from "@faire/web/common/localization/useLocalization";
import { QueryParameters as FeaturedLeanProductTilesParameters } from "@faire/web-api--source/endpoints/www/api/v2/search/brandToken/featured-products/get";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { useEffect, useState } from "react";

export const useProductImages = (brandToken?: string, pageSize?: number) => {
  const { getFeaturedLeanProductTiles } = useProductCacheStore([
    "getFeaturedLeanProductTiles",
  ]);

  const [productImages, setProductImages] = useState<(IImage | undefined)[]>();
  const [isPending, setIsPending] = useState(false);
  const {
    intl: { locale },
  } = useLocalization();
  useEffect(() => {
    (async () => {
      try {
        setIsPending(true);
        const productsResponse = await getFeaturedLeanProductTiles(
          brandToken ?? "",
          FeaturedLeanProductTilesParameters.build({
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            pageSize: pageSize,
            locale: locale,
          })
        );
        const productImages = productsResponse.product_tiles.map(
          (productTile) => productTile.best_image
        );
        setProductImages(productImages);
        setIsPending(false);
      } catch (error) {
        setProductImages(undefined);
        setIsPending(false);
      }
    })();
  }, [brandToken, getFeaturedLeanProductTiles, locale, pageSize]);

  return { productImages, isPending };
};
